import { render, staticRenderFns } from "./cycleWarn_page.vue?vue&type=template&id=adf746a6&scoped=true"
import script from "./cycleWarn_page.vue?vue&type=script&lang=js"
export * from "./cycleWarn_page.vue?vue&type=script&lang=js"
import style0 from "./cycleWarn_page.vue?vue&type=style&index=0&id=adf746a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf746a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adf746a6')) {
      api.createRecord('adf746a6', component.options)
    } else {
      api.reload('adf746a6', component.options)
    }
    module.hot.accept("./cycleWarn_page.vue?vue&type=template&id=adf746a6&scoped=true", function () {
      api.rerender('adf746a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/cycleWarn_page.vue"
export default component.exports